import { isString } from '@cwp/utils'

export function toCamelCase (str) {
  if (!str || !isString(str)) return ''
  return str.replace(/-([a-z])/g, g => g[1].toUpperCase())
}
